'use client';

import { c as _c } from "react/compiler-runtime";
import closeIcon from '@public/images/close_white.svg';
import Image from 'next/image';
export const TopNavV6MobileCloseHeader = t0 => {
  const $ = _c(3);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src={closeIcon} width={20} height={20} alt="Close menu" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClick) {
    t2 = <div className="flex h-12 items-center justify-end px-4"><button className="flex size-6 appearance-none items-center justify-center" onClick={onClick} data-testid="closeMobileMenu">{t1}</button></div>;
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};